"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM7 3h2v2H7V3zm3 10H6v-1h1V7H6V6h3v6h1v1z"];
//# sourceMappingURL=info-sign.js.map